<template>
  <v-menu
    offset-y
    left
    transition="slide-y-transition"
    min-width="5%"
  >
    <template #activator="menu">
      <v-tooltip bottom>
        <template #activator="tooltip">
          <v-btn
            class="ml-2 d-flex flex-column align-center"
            v-bind="{ ...menu.attrs, ...tooltip.attrs, ...$attrs }"
            v-on="{ ...menu.on, ...tooltip.on, ...$listeners }"
            icon
          >
            <CountryFlag
              class="mb-0"
              :country="getFlag(current)"
              size="normal"
            />
            <span> {{ current }} </span>
          </v-btn>
        </template>
        <span> {{ $t("commons.language") }} </span>
      </v-tooltip>
    </template>
    <avs-card
      cardClass="rounded-0"
      noTitle
    >
      <template v-slot:content>
        <v-list>
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            class="justify-start"
            @click="changeLanguage(item.short)"
          >
            <CountryFlag
              :country="getFlag(item.short)"
              size="normal"
            />
            <span class="pl-3 pt-3"> {{ item.language }} </span>
          </v-list-item>
        </v-list>
      </template>
    </avs-card>
  </v-menu>
</template>

<script>
import CountryFlag from "vue-country-flag"

export default {
  name: "Languages",
  components: {
    CountryFlag
  },
  data() {
    return {
      items: this.$store.state.app.languages
    }
  },
  computed: {
    current() {
      return this.$store.state.app.locale
    }
  },
  methods: {
    changeLanguage(newValue) {
      this.$i18n.locale = newValue
      this.$store.commit("app/setLocale", newValue)
    },
    getFlag(locale) {
      return locale === "fr" ? "fr" : locale
    }
  }
}
</script>
